import React from "react";
import { useMsal } from "@azure/msal-react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { useSocket } from "../../contexts/SocketContext";

/**
 * Renders a sign out button 
 */
export const SignOutButton = () => {
  const { instance } = useMsal();
  const { setAuthToken } = useSocket();

  const handleLogout = (logoutType) => {
    // 刪除自定義的 token
    // sessionStorage.removeItem("flaskAccessToken");
    sessionStorage.removeItem("storageAccessToken");
    setAuthToken(null); // 會清掉 sessionStorage + 斷線

    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }


    // ✅ 強制刷新畫面避免快取舊資料
    // window.location.reload(); // 建議放在 redirect logout callback
  };

  return (
    <DropdownButton
      variant="secondary"
      className="ml-auto"
      drop="start"
      title="Sign Out"
    >
      <Dropdown.Item as="button" onClick={() => handleLogout("popup")}>
        Sign out using Popup
      </Dropdown.Item>
    </DropdownButton>
  );
};
      // <Dropdown.Item as="button" onClick={() => handleLogout("redirect")}>
      //   Sign out using Redirect
      // </Dropdown.Item>